const Joi = require("joi");

const memberSchema = (data) => {
  const schema = Joi.object({
    firstName: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$"))
      .required()
      .max(25)
      .messages({
        "string.pattern.base": "Please enter valid First Name.",
        "string.max": "Please enter First Name with fewer than 25 characters.",
        "any.required": "Please enter First Name.",
        "string.empty": "Please enter First Name.",
      }),

    lastName: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$"))
      .required()
      .max(25)
      .messages({
        "string.pattern.base": "Please enter Valid Last Name.",
        "string.max": "Please enter Last name with fewer than 25 characters.",
        "string.empty": "Please enter Last Name.",
        "any.required": "Please enter Last Name.",
      }),

    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .pattern(
        new RegExp(
          /^(?!.*\.\.)[a-zA-Z0-9._!#$*+%+'-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
        )
      )
      .required()
      .messages({
        "string.email": "Please enter valid email.",
        "string.pattern.base": "Please enter valid email.",
        "string.empty": "Please enter email.",
        "any.required": "Please enter email.",
      }),

    phoneNumber: Joi.string()
      .trim()
      .pattern(/^\(\d{3}\)\s\d{3}-\d{4}$/)
      .optional() // not required
      .allow("")
      .messages({
        "string.pattern.base":
          "Please enter a valid phone number (e.g., (777) 777-7777).",
      }),

    // committees: Joi.array()
    //   .items(
    //     Joi.string().required().messages({
    //       "string.base": "Invalid Committee", //not a string
    //       "any.required": "Committee ID is required.",
    //     })
    //   )
    //   .min(1)
    //   .required()
    //   .messages({
    //     "array.base": "Committees must be an array.",
    //     "array.min": "Please select at least one committee.",
    //     "any.required": "Committees are required.",
    //   }),
    // committees: Joi.array()
    //   .items(
    //     Joi.string().required().messages({
    //       "string.base": "Invalid Committee", // not a string
    //       "any.required": "Committee ID is required.",
    //     })
    //   )
    //   .min(1)
    //   .when("role", {
    //     is: Joi.valid(1),
    //     then: Joi.required().messages({
    //       "array.base": "Committees must be an array.",
    //       "array.min": "Please select at least one committee.",
    //       "any.required": "Committees are required.",
    //     }),
    //     otherwise: Joi.optional(),
    //   }),
    committees: Joi.when("role", {
      is: Joi.valid(1, 2),
      then: Joi.array()
        .items(
          Joi.string().required().messages({
            "string.base": "Invalid Committee",
            "any.required": "Committee ID is required.",
          })
        )
        .min(1)
        .required()
        .messages({
          "array.base": "Committees must be an array.",
          "array.min": "Please select at least one committee.",
          "array.includesRequiredUnknowns": "Please select at least one committee.",
          "any.required": "Please select at least one committee.",
        }),
      otherwise: Joi.optional(),
    }),

    // committeesAdmin: Joi.when("role", {
    //   is: 2,
    //   then: Joi.array()
    //     .items(
    //       Joi.string().required().messages({
    //         "string.base": "Invalid Committee",
    //         "any.required": "Committee ID is required.",
    //       })
    //     )
    //     .min(1)
    //     .required()
    //     .messages({
    //       "array.base": "Committees must be an array.",
    //       "array.min": "Please select at least one committee.",
    //       "any.required": "Committees are required.",
    //     }),
    //   otherwise: Joi.optional(),
    // }),

    password: Joi.string()
      // .pattern(/^[A-Za-z\d~!@#$%^&*()_+{}|:"<>?\[\]\\\-=',./\s]{8,}$/)
      .pattern(
        new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
      )
      .when(Joi.ref("$isEditPage"), {
        is: false, // if not edit page => required
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "string.pattern.base":
          "Password must be at least 8 characters long and can include letters, numbers, spaces, and special characters.",
        "any.required": "Please enter Password.",
        "string.empty": "Please enter Password.",
      }),

    confirmPassword: Joi.string()
      .valid(Joi.ref("password"))
      .when(Joi.ref("$isEditPage"), {
        is: false,
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "any.only": "Confirm password must match the password.",
        "any.required": "Please enter confirm password.",
        "string.empty": "Please enter confirm password.",
      }),

    role: Joi.number().valid(1, 2, 3).required().messages({
      "any.only": "Please Select Valid Role",
      "any.required": "Please Select Valid Role",
      "string.empty": "Please Select Valid Role",
    }),

    // organization: Joi.string().when("participateKids", {
    //   is: 1,
    //   then: Joi.string().trim().required().messages({
    //     "any.required":
    //       "Organization is required when participating with kids.",
    //     "string.empty": "Organization cannot be empty.",
    //   }),
    //   otherwise: Joi.string().allow("").optional(),
    // }),
    organization: Joi.string()
      .trim()
      .max(256)
      .when("participateKids", {
        is: 1,
        then: Joi.string().required().messages({
          "string.empty": "Organization name is required.",
          "string.max": "Organization name must be fewer than 256 characters.",
        }),
        otherwise: Joi.string().optional().allow(""),
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = memberSchema;
